import React from 'react';
import Breadcrumb from '../common/Breadcrumb';

const FeeStructure = () => {
  
  return (
    <>
      <Breadcrumb 
        pageTitle="Fee Structure"
        breadcrumbItems={[
          { label: "Home", link: "/" },
          { label: "Fee Structure" }
        ]}
        backgroundImage="images/banner/slide-2.png"
      />

      <section className="space-ptb">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-12 text-center">
              <div className="section-title">
                <h2>Fee Structure</h2>
                <div className="curved-line mx-auto mt-3"></div>
              </div>             
              <div 
                style={{
                  width: '100%',
                  height: 'calc(100vh + 220px)', 
                  minHeight: '700px',
                  border: '1px solid #e0e0e0',
                  borderRadius: '8px',
                  overflow: 'hidden',
                  background: '#f8f9fa',
                  margin: '20px auto',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.08)'
                }}
              >
                <iframe
                    src={`/Feestructure.pdf`}
                    width="100%"
                    height="100%"
                    style={{ border: 'none' }}
                    title="Fee Structure"
                    />
              </div>              
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default FeeStructure;